import { observer } from 'mobx-react-lite'
import type { JobDetailsViewModel } from '@/features/jobs/details/JobDetailsViewModel'
import type { TaxJobDetailsViewModel } from '@/features/jobs/details/tax-type/TaxJobDetailsViewModel'
import { TranscriptDownloadSectionContainer } from '@/features/jobs/details/consultation/components/TranscriptDownloadSection'
import { DocumentsSectionContainer } from '@/features/jobs/details/components/DocumentsSection'
import { PageLayout } from '@/features/jobs/details/components/PageLayout'
import { MissingChecklistDocumentsSectionContainer } from '@/features/jobs/details/tax-type/info-gathering/components/ChecklistItemsSections/MissingChecklistDocumentsSectionContainer'
import { ChecklistStatusSectionContainer } from '@/features/jobs/details/tax-type/info-gathering/components/ChecklistStatusCard/ChecklistStatusCardSectionContainer'
import { useActivation } from '@/hooks/view-model-hooks'
import { FinalReturnDownloadSectionContainer } from '@/features/jobs/details/tax-type/components/FinalReturn/FinalReturnContainers'

export interface TaxJobDocsTabProps {
  vm: JobDetailsViewModel
}

/**
 * The TaxJobDocsTab
 */
export default observer(function TaxJobDocsTab({ vm }: TaxJobDocsTabProps) {
  useActivation(vm.docsVm)

  // We know this is safe.
  const typeVm = vm.typeVm as TaxJobDetailsViewModel
  const consultationManagerVm = typeVm.consultationManagerVm
  return (
    <>
      <PageLayout
        asideTop={
          <>
            <FinalReturnDownloadSectionContainer vm={typeVm} />
            {consultationManagerVm.consultation && (
              <TranscriptDownloadSectionContainer vm={consultationManagerVm} />
            )}
            <ChecklistStatusSectionContainer typeVm={typeVm} />
          </>
        }
      >
        <MissingChecklistDocumentsSectionContainer
          vm={typeVm.infoGatheringVm}
        />
        <DocumentsSectionContainer vm={vm} />
      </PageLayout>
    </>
  )
})
